// apps/client/src/game/interactions/fish.ts (M1-T15) — with the rod in hand, cast at the nearest personal shadow in front within
// casting range; while the line is out, A reels (B cancels, game/systems/fishing.ts).
import { getEntry, tuning } from '@whiskerton/content';
import type { Interaction } from '../interact';
import { loopOf } from '../systems/fishing';
import { fishingLayerOf } from '../../world/fishing';

/** A shadow counts as "in front" within this cosine of your facing (about ±60°). */
const FRONT_COS = 0.5;

export const interaction: Interaction = {
  id: 'fish',
  find(ctx) {
    const loop = loopOf(ctx.game);
    if (loop && (loop.phase === 'waiting' || loop.phase === 'bite')) return { id: 'reel', at: ctx.pos, verb: 'hud.verbReel', priority: 100 };
    const tool = ctx.tool && getEntry(ctx.tool);
    if (ctx.space !== 'out' || !tool || tool.kind !== 'tool' || tool.tool !== 'rod' || loop?.phase !== 'idle') return null;
    // A catch waiting in your hand (pockets full) must go first: the server answers a cast with hand_full (M1 playtest).
    if (ctx.store.you?.items.some((i) => i.at.loc === 'hand')) return null;
    const fx = Math.sin(ctx.f), fy = Math.cos(ctx.f);
    let best: { id: string; d: number; x: number; y: number } | null = null;
    for (const s of fishingLayerOf(ctx.game)?.shadows() ?? []) {
      const dx = s.x - ctx.pos.x, dy = s.y - ctx.pos.y, d = Math.hypot(dx, dy);
      if (d < 1e-3 || d > tuning.fishing.castRange || (dx * fx + dy * fy) / d < FRONT_COS) continue;
      if (!best || d < best.d) best = { id: s.id, d, x: s.x, y: s.y };
    }
    return best && { id: best.id, at: { x: best.x, y: best.y }, verb: 'hud.verbCast', priority: 60 };
  },
  run(ctx, c) {
    const loop = loopOf(ctx.game);
    if (!loop) return;
    if (c.id === 'reel') { ctx.game.you()?.avatar.play('reel'); void loop.press(); return; }
    const s = fishingLayerOf(ctx.game)?.shadows().find((x) => x.id === c.id);
    if (s) void loop.cast(s);
  },
};
